import { Component } from '@angular/core';


@Component({
  selector: 'caret-arrow',
  template: require('./caret-arrow.component.html')
})
export class CaretArrowComponent {
}
